import {mapState} from "vuex";

// 学年
export const userYearList = {
    data(){
        return {
            startYearList: [],  //学年
        };
    },
    // computed: {
    //     ...mapState("common", {
    //         startYearList: state => state.startYearList, //学年
    //     }),
    // },
    created(){
        // getUserYearData();
    },
    methods: {
        // 获取学年
        getUserYearData(){
            return new Promise((resolve, reject) => {
                // 获取学年
                this.$store.dispatch("common/getStartYearList").then(res => {
                    this.startYearList = res;
                    resolve(res);
                }); 
            });
        },
        // 默认选中当前学年
        selectCurrentYear(){
            return new Promise((resolve, reject) => {
                let date = new Date();
                let currentYear = date.getFullYear();
                if(this.condition){
                    this.condition.start_year = currentYear;
                }
                resolve(true);
            });
        },
    },
};
